import { IColumn } from '../types';
import { defaultHeaderRenderer } from '../headers';
import { LeftAlign } from '../styles';
import { CellEventsHandler } from '../formatters';
import { CellProps } from '../../types';

const OfferFormatter = (cellProps: CellProps) => {
  const alignedValue = <LeftAlign>{cellProps.row.offerId}</LeftAlign>;

  return <CellEventsHandler cellProps={cellProps}>{alignedValue}</CellEventsHandler>;
};

export const OfferColumn = (): IColumn => ({
  item: {
    key: 'offerId',
    name: 'ID',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(128px, 1fr)',
    formatter: OfferFormatter,
  },
  visible: ({ isOfferEnabled }) => {
    return !!isOfferEnabled;
  },
});
